import { render, staticRenderFns } from "./FeedRecentButtons.vue?vue&type=template&id=38f4e9e6&scoped=true&"
import script from "./FeedRecentButtons.vue?vue&type=script&lang=ts&"
export * from "./FeedRecentButtons.vue?vue&type=script&lang=ts&"
import style0 from "./FeedRecentButtons.vue?vue&type=style&index=0&id=38f4e9e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f4e9e6",
  null
  
)

export default component.exports